import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import $ from '../../lib/jquery-pivot-setup';
import {get as _get} from "lodash-es";
import {HotInstance} from "../../services/hot-instance";

@Component({
    selector: 'pivot-view',
    imports: [],
    templateUrl: 'pivot-view.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PivotViewComponent implements OnInit, AfterViewInit {
    @ViewChild('pivot_out') el: ElementRef;

    @Input() hot: HotInstance;
    /**
     * Optional pre-loaded object dataset (e.g. the full unfiltered set served by a
     * cache service). When provided, rows are projected from these objects using
     * each column's `data` path (string) or accessor (function). When omitted, we
     * fall back to whatever Handsontable currently holds.
     *
     * Note: read once in `ngOnInit`; mutating this input later won't update the
     * pivot UI. Hosts that need to refresh the pivot should destroy and recreate
     * this component (e.g. via `*ngIf` toggling) — see collector-mapper-sheet-view
     * which gates with `*ngIf="fullDatasetLoaded"`.
     */
    @Input() data?: any[];
    /**
     * Optional extra columns appended to the pivot projection only — useful for
     * surfacing fields the table doesn't show but that the user may want to
     * filter/group by inside the pivot UI (e.g. account name).
     */
    @Input() extraColumns?: { title: string; accessor: (item: any) => any }[];

    titles;
    rows;
    $: any;

    ngOnInit(): void {
        const columns = this.hot.settings.columns as any[];
        const extraColumns = this.extraColumns ?? [];

        if (this.data) {
            this.titles = [...columns.map(col => col.title), ...extraColumns.map(c => c.title)];
            this.rows = this.data.map(item => {
                const row: Record<string, any> = {};
                columns.forEach(col => {
                    // Function-typed `col.data` is a Handsontable accessor with signature
                    // `(row, value) => ...` (e.g. HandsontableGeneratorService.genLookupDataSource).
                    // Calling it with just `(item)` (value === undefined) takes the getter
                    // branch and returns the lookup title we want for pivot grouping.
                    const value = typeof col.data === 'function'
                        ? col.data(item)
                        : _get(item, col.data);
                    row[col.title] = value;
                });
                extraColumns.forEach(col => {
                    row[col.title] = col.accessor(item);
                });
                return row;
            });
        } else {
            // Fallback uses Handsontable's positional value[] — extraColumns have no source here.
            this.titles = columns.map(col => col.title);
            this.rows = this.hot.instance.getData()
                .map(item => {
                    const row: Record<string, any> = {};
                    this.titles.forEach((title, index) => row[title] = item[index]);
                    return row;
                });
        }
    }

    ngAfterViewInit() {
        // @ts-ignore
        $(this.el.nativeElement).pivotUI(
            this.rows, {
                renderers: $.extend(
                    // @ts-ignore
                    $.pivotUtilities.renderers,
                    // @ts-ignore
                    $.pivotUtilities.c3_renderers,
                    // @ts-ignore
                    $.pivotUtilities.d3_renderers,
                    // @ts-ignore
                    $.pivotUtilities.export_renderers
                ),
                hiddenAttributes: [""],
                aggregatorName: 'Count',
                menuLimit: 1000
            }).show();
    }
}
